export const sortByCollectionName = (isAsc, list) =>
  list.sort((a, b) => {
    const NAME_A = a.name.toUpperCase();
    const NAME_B = b.name.toUpperCase();
    let comparison = 0;

    if (isAsc) {
      if (NAME_A > NAME_B) comparison = 1;
      else if (NAME_A < NAME_B) comparison = -1;
    } else {
      if (NAME_A < NAME_B) comparison = 1;
      else if (NAME_A > NAME_B) comparison = -1;
    }
    return comparison;
  });

export const sortConversations = (list) =>
  [...list].sort((a, b) => {
    // First sort by business_unread_messages_count (descending - higher count first)
    const unreadDiff = (b.business_unread_messages_count || 0) - (a.business_unread_messages_count || 0);
    if (unreadDiff !== 0) {
      return unreadDiff;
    }
    // Then sort by last_message_sent (descending - most recent first)
    return new Date(b.last_message_sent).getTime() - new Date(a.last_message_sent).getTime();
  });
